// extracted by mini-css-extract-plugin
export default {"blueButton":"BlueButton_blueButton__33c8C","cancel":"BlueButton_cancel__NaQ41","loader":"BlueButton_loader__UWkRH","spin":"BlueButton_spin__1pIi6"};